export default {
    //国际化配置
    Config: {
        env: 'en',//语言
        system: 'Zoomlion data processing platform',//中联数据资产管理
        Confirm: 'Confirm',
        Cancel: 'Cancel',
    },
 }



// WEBPACK FOOTER //
// ./src/components/lang/en.js